import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { UpdateAlarmStatusRequest } from '../models/requests/update-alarm-status.request';

@Injectable({
  providedIn: 'root',
})
export class AlarmService {
  constructor(private apiService: ApiService) {}

  public UpdateAlarmStatus(
    updateAlarmStatusRequest: UpdateAlarmStatusRequest
  ): Observable<any> {
    return this.apiService.post(
      '/Alarm/UpdateStatus',
      updateAlarmStatusRequest
    );
  }
}
